import { render } from "./TranslationManager.vue?vue&type=template&id=2d8a5366"
import script from "./TranslationManager.vue?vue&type=script&lang=js"
export * from "./TranslationManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__